import React from 'react';

import DateItem from './DateItem';
import type { RadioDatePickerDate } from './DateItem';

interface Props {
  startDate?: Date | string | null;
  dateGroups: Record<string, RadioDatePickerDate[]>;
  onSelectDate: (date: RadioDatePickerDate) => void;
}

const DateRadioButtonPicker = ({ startDate, dateGroups, onSelectDate }: Props) => {
  return (
    <div className="radio-datepicker">
      {Object.keys(dateGroups).map(function (dateGroup, i) {
        return (
          <div className="month-wrapper" key={i}>
            <div className="month-body">
              {dateGroups[dateGroup].map(function (date, idx) {
                return <DateItem key={idx} date={date} startDate={startDate} onSelectDate={onSelectDate} />;
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default DateRadioButtonPicker;
